import React from "react";

function SealSection() {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <h2 className="text-3xl font-bold text-primary mb-6">Our Commitment</h2>
        <p className="text-lg text-gray-700 mb-8">
          This document is authenticated with the official seal and signature of Chiranthan Enterprises, 
          ensuring our unwavering dedication to quality and excellence.
        </p>
        
        {/* Image Section */}
        <div className="flex justify-center items-center">
          <img
            src="/assets/Founder.png"
            alt="Chiranthan Enterprises Seal and Signature"
            className="w-128 h-auto rounded-lg shadow-md"
          />
        </div>

        {/* Decorative Elements */}
        <div className="mt-8">
          <div className="w-16 h-1 bg-gradient-to-r from-primary to-secondary mx-auto"></div>
        </div>
      </div>
    </section>
  );
}

export default SealSection;
